import { useInviteEligibilityCheck } from '../hooks/use-invite-eligibility-check';

/**
 * Mounts once inside the invite form (FormProvider) to own the eligibility
 * query side effects — syncing block outcomes onto email fields as RHF errors.
 * Banners read the same React Query cache via {@link useInviteEligibilityCheck}.
 */
export function InviteEligibilityController() {
  useInviteEligibilityCheck({ syncFieldErrors: true });
  return null;
}
